import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAccountWorkspace } from "@/lib/account-workspace";
import { useAuth } from "@/lib/auth";

type Membership = {
  user_id: number;
  role: "owner" | "admin" | "member";
  disabled: boolean;
};

export function useKbCanWrite() {
  const { accountId, accessKind } = useAccountWorkspace();
  const { user } = useAuth();
  const [canWrite, setCanWrite] = useState(false);

  useEffect(() => {
    if (!accountId || !user?.id || accessKind !== "membership") {
      setCanWrite(false);
      return;
    }

    let cancelled = false;
    api
      .fetchForAccount<{ memberships: Membership[] }>(accountId, `/accounts/${accountId}/memberships`)
      .then(({ memberships }) => {
        if (cancelled) return;
        const membership = memberships.find((item) => item.user_id === user.id);
        setCanWrite(
          Boolean(membership && !membership.disabled && (membership.role === "owner" || membership.role === "admin")),
        );
      })
      .catch(() => {
        if (!cancelled) setCanWrite(false);
      });

    return () => {
      cancelled = true;
    };
  }, [accountId, accessKind, user?.id]);

  return canWrite;
}
